export const formatBytes = bytes => {
  if (!bytes || bytes === 0) return "0 B";
  const KB = 1024;
  const MB = KB * 1024;
  if (bytes >= MB) {
    return `${(bytes / MB).toFixed(bytes % MB === 0 ? 0 : 1)} MB`;
  }
  if (bytes >= KB) {
    return `${(bytes / KB).toFixed(bytes % KB === 0 ? 0 : 1)} KB`;
  }
  return `${bytes} B`;
};
